export default "__VITE_ASSET__DNACF7pi__"